import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-days-inventory-left',
  templateUrl: 'stock-days-inventory-left.html',
})
export class StockDaysInventoryLeftPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  no_data = false;
  date_no_data;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'DAYS_TO_END', name: this.translate.instant('general-dias-restantes') },
    { prop: 'NAME', name: this.translate.instant('general-nombre') },
    { prop: 'QUANTITY', name: this.translate.instant('general-inventario') },
    { prop: 'PURCHASE', name: this.translate.instant('general-compras') },
    { prop: 'SALES', name: this.translate.instant('home-dashboard-top-sales-vendidos') },
    { prop: 'SALES_AVG', name: this.translate.instant('general-media-por-dia') },

  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController) {
    this.checkDateBeforeGet();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.checkDateBeforeGet();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/stock_days_inventory_left', params, {})
      .subscribe(async response => {
        //list
        this.rows = response['list'];
        this.temp = response['list'];

        this.date_no_data = response['date_no_data'];
        this.no_data = response['no_data'];

        //rouns average percentage


        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.stock_summary_name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  checkDateBeforeGet() {
    if (this.advancedAnalyticsServices.date2 >= moment().format('YYYY-MM-DDTHH:mm:ss')) {
      this.advancedAnalyticsServices.date2 = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      //msg
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-fecha-final-no-anterior-fecha-actual'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    this.getAnalyticsData();

  }

  export() {
    const rows_send = this.rows.map((x) => {
      return {
        DAYS_TO_END: x.DAYS_TO_END,
        NAME: x.NAME,
        QUANTITY: x.QUANTITY,
        PURCHASE: x.PURCHASE,
        SALES: x.SALES,
        SALES_AVG: x.SALES_AVG
      };
    });
    const params = new HttpParams()
      .set('data', JSON.stringify(rows_send))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-days-inventory-left/stock-days-inventory-left.ts